//import { rejects } from "assert";

class WebService {
    url: string = "../Ashx/ActMain.ashx";
    urlP: string = "../Ashx/Performance.ashx";
    testUID:string|null = null
    constructor() {
        if (process.env.NODE_ENV == "development") {
            this.url = "http://localhost:56400/Ashx/ActMain.ashx";
            //this.urlP = "http://localhost:56400/Ashx/Performance.ashx";

            //this.testUID = 'E222600814'
            //this.testUID = 'A220800045'
            //this.testUID = 'F230376659'
            //this.testUID = 'a126598784'
            //this.testUID = 'A226078181'
            //this.testUID = 'L120966750'
            //this.testUID = 'G221847539'
            this.testUID = 'M221716220'
            
        }
        console.log("init webservice ", this.url)
    }

    LRCurrentYearCheck = async (): Promise<object> => {
        const fd = new FormData();
        return this.Call("LRCurrentYearCheck", fd)
    }

    //20250123壽產第一第二年度狀態
    
    getLRStatus = async (ActType:string): Promise<object> => {
        const fd = new FormData();
        fd.append("ActType", ActType);
        return this.Call("GetLRStatus", fd);
    }

    getActMainList = async (actType:string, class2: string): Promise<object> => {
        const fd = new FormData();
        fd.append("ActType", actType);
        fd.append("class2", class2 ? class2 : "");
        return this.Call("GetActMainList", fd)
    }

    getActMainListBCH125 = async (actType: string, class2: string): Promise<object> => {
        const fd = new FormData();
        fd.append("ActType", actType);
        return this.Call("GetActMainListBCH125", fd)
    }

    //新的呼叫func
    Call = (RequestType:string, fd:FormData):object=>{
        fd.append("RequestType",RequestType)
        return new Promise((resolve, reject) => {
            if(this.testUID){
                fd.append("TestUID", this.testUID)
            }
            fetch(this.url, {
                method: 'POST',
                body: fd,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result);
            }).catch((error) => {
                alert(`Promoted.${RequestType} 讀取資料失敗`)
                console.error(error)
            })
        })
    }
    
    asyncGetActCover = async (ActID: string): Promise<object> => {
        return await this.GetActCover(ActID);
    }

    GetActCover = (ActID: string): object => {
        let formData = new FormData();
        formData.append("RequestType", "GetActCover");
        formData.append("ActID", ActID);
        if(this.testUID){
            formData.append("TestUID", this.testUID)
        }
        return new Promise((resolve, reject) => {
            fetch(this.url, {
                method: 'POST',
                mode: 'cors',
                body: formData
            }).then(response => {
                if (response.ok) {
                    return response.json();
                }
            }).then(res => {
                resolve(res)
            }).catch(error => {
                console.error('[HIB168 錯誤]=>jsonip 取得失敗:', error)
                reject()
            });
        })
    }

    asyncGetCardPoster = async (FPath: string): Promise<object> => {
        return await this.GetCardPoster(FPath);
    }

    GetCardPoster = (FPath: string): object => {
        let formData = new FormData();
        formData.append("RequestType", "GetCardPoster");
        formData.append("FPath", FPath);
        if(this.testUID){
            formData.append("TestUID", this.testUID)
        }
        return new Promise((resolve, reject) => {
            fetch(this.url, {
                method: 'POST',
                mode: 'cors',
                body: formData
            }).then(response => {
                if (response.ok) {
                    return response.json();
                }
            }).then(res => {
                resolve(res)
            }).catch(error => {
                console.error('[HIB168 錯誤]=>jsonip 取得失敗:', error)
                reject()
            });
        })
    }
    
    asyncGetActMainOtsList = async (class1: string): Promise<object> => {
        return await this.GetActMainOtsList(class1);
    }

    GetActMainOtsList = (class1: string): object => {
        let formData = new FormData();
        formData.append("RequestType", "GetActMainOtsList");
        formData.append("class1", class1 ? class1 : "A");
        if(this.testUID){
            formData.append("TestUID", this.testUID)
        }
        return new Promise((resolve, reject) => { 
            fetch(this.url, {
                method: 'POST',
                mode: 'cors',
                body: formData
            }).then(response => {
                if (response.ok) {
                    return response.json();
                }
            }).then(res => {
                resolve(res)
            }).catch(error => {
                console.error('[HIB168 錯誤]=>jsonip 取得失敗:', error)
                reject()
            });
        })
    }


    //法尊狀態
    asyncGetLowStateDashboard = async (): Promise<object> => {
        return await this.GetLowStateDashboard();
    }

    GetLowStateDashboard = (): object => { 
        let formData = new FormData();
        formData.append("RequestType", "GetLowStateDashboard")
        if(this.testUID){
            formData.append("TestUID", this.testUID)
        }

        return new Promise((resolve, reject) => {
            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                //console.log(result)
                resolve(result.Data[0])
            }).catch(error => {
                console.error(error);
            })
        })
    }

    asyncGetShowPage1 = async (): Promise<object> => {
        return await this.GetShowPage1();
    }

    GetShowPage1 = (): object => { 
        let formData = new FormData();
        formData.append("RequestType", "ShowCourseState")
        if(this.testUID){
            formData.append("TestUID", this.testUID)
        }
        return new Promise((resolve, reject) => {
            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result.Data)
            }).catch(error => {
                console.error(error);
            })
        })
    }

    asyncGetActCompleteList = async (): Promise<object> => {
        return await this.GetActCompleteList();
    }

    GetActCompleteList = (): object => { 
        let formData = new FormData();
        formData.append("RequestType", "GetActCompleteList")
        if(this.testUID){
            formData.append("TestUID", this.testUID)
        }
        return new Promise((resolve, reject) => {
            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result.Data)
                //HibTable(result.Data);//設定客製的HibTable
            }).catch(error => {
                console.error(error);
            })
        })
    }


    asyncGetLowStateInfo = async (): Promise<object> => {
        return await this.GetLowStateInfo()
    }

    GetLowStateInfo = (): object => { 
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("RequestType", "GetLowStateInfo")
            if(this.testUID){
                formData.append("TestUID", this.testUID)
            }
            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result.Data);
            })
        })
    }

    //使用者報名
    asyncDoApplyCourse = async (ActID: string, Answer: string): Promise<object> => {
        return await this.DoApplyCourse(ActID, Answer)
    }

    DoApplyCourse = (ActID: string, Answer: string): object => {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("RequestType", "DoApplyCourse")
            formData.append("ActID", ActID)
            formData.append("Answer", Answer ? Answer : "Y")
            if(this.testUID){
                formData.append("TestUID", this.testUID)
            }
            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result.Data);
            })
        })
    }

    //取得問卷
    asyncGetQuestionnaire = async (ExamID: number): Promise<object> => {
        return await this.GetQuestionnaire(ExamID)
    }

    GetQuestionnaire = (ExamID: number): object => {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("RequestType", "GetQuestionnaire")
            formData.append("ExamID", ExamID.toString())
            if(this.testUID){
                formData.append("TestUID", this.testUID)
            }
            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result.Data);
            })
        })
    }

     //送出回答問卷內容
    asyncAnswerQuestionnaire = async (ExamID: number, ActID: string, QSNo: number, ItemID: string|undefined, ItemTxt: string|undefined ): Promise<object> => {
        return await this.AnswerQuestionnaire(ExamID, ActID, QSNo, ItemID, ItemTxt)
    }

    AnswerQuestionnaire = (ExamID: number, ActID: string, QSNo: number, ItemID: string|undefined, ItemTxt: string|undefined): object => {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("RequestType", "AnswerQuestionnaire")
            formData.append("ExamID", ExamID.toString())
            formData.append("ActID", ActID.toString())
            formData.append("QSNo", QSNo.toString())
            if(this.testUID){
                formData.append("TestUID", this.testUID)
            }
            
            if(ItemID){
                formData.append("ItemID", ItemID.toString())
            }
            if(ItemTxt){
                formData.append("ItemTxt", ItemTxt.toString())
            }

            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result.Data);
            })
        })
    }

    //取得回答問卷內容
    asyncGetAnswer = async (ActID:string, ExamID:number): Promise<object> => {
        return await this.GetAnswer(ActID, ExamID)
    }

    GetAnswer = (ActID:string, ExamID:number): object => {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("RequestType", "GetAnswer")
            formData.append("ActID", ActID.toString())
            formData.append("ExamID", ExamID.toString())
            if(this.testUID){
                formData.append("TestUID", this.testUID)
            }

            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result.Data);
            })
        })
    }
    
    //取得摸彩券
    asyncGetPerformanceTickets = async (year:number): Promise<object> => {
        return await this.GetPerformanceTickets(year)
    }

    GetPerformanceTickets = (year:number): object => {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("RequestType", "GetPerformanceTickets")
            formData.append("QueryYear", year.toString())
            if(this.testUID){
                formData.append("TestUID", this.testUID)
            }

            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result.Data[0]);
            })
        })
    }

    //檔案上傳
    asyncRegFileUpload = async (ActID:string, base64Data:string): Promise<object> => {
        return await this.RegFileUpload(ActID, base64Data)
    }

    RegFileUpload = (ActID:string, base64Data:string): Promise<object> => {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("RequestType", "RegFileUpload")
            formData.append("ActID", ActID)
            formData.append("file64", base64Data);
            if(this.testUID){
                formData.append("TestUID", this.testUID)
            }

            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result);
            })
        })
    }

    //檔案下載預覽
    asyncRegFileDownload = async ( fileName:string): Promise<object> => {
        return await this.RegFileDownload(fileName)
    }

    RegFileDownload = (fileName:string): Promise<object> => {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("RequestType", "RegFileDownload")
            formData.append("fileName", fileName)
            if(this.testUID){
                formData.append("TestUID", this.testUID)
            }
            
            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result);
            })
        })
    }
    
}

export default WebService